module.exports = __webpack_public_path__ + "static/media/inc-radio.ea033ee4.jpg";